import axios from 'axios'
import qs  from 'qs';
// 在config.js文件中统一存放一些公共常量，方便之后维护
import {config} from '@/config'
import router from '@/router'
import store from '@/store'
import {Message} from 'element-ui'

/**
 * axios请求拦截器
 * @param {object} config axios请求配置对象
 * @return {object} 请求成功或失败时返回的配置对象或者promise error对象
 * **/
axios.interceptors.request.use(config => {
  // 这里的config包含每次请求的内容
  let token = store.state.token
  if (token) {
    //  存在将api_token写入 request header
    config.headers.Authorization = 'bearer ' + token //jwt
  }
  return config
})

/**
 * axios 响应拦截器
 * @param {object} response 从服务端响应的数据对象或者error对象
 * @return {object} 响应成功或失败时返回的响应对象或者promise error对象
 **/
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})

/**
 * 请求发出后检查返回的状态码,统一捕获正确和错误的状态码，正确就直接返回response,错误就自定义一个返回对象
 * @param {object} response 响应对象
 * @return {object} 响应正常就返回响应数据否则返回错误信息
 **/
function checkStatus(response) {
  if (response === undefined) {
    Message.error({
      message: '请求失败!',
    })
    return
  }
  // 正确返回
  if (response && (response.status === 200)) {
    return response.data
  } else { // 全局错误处理  304 400也在此处理
    statusCode(response)
  }
}

function statusCode(response) {
  switch (response.status) {
    case 200:
      Message.error({
        message: '未授权，请登录',
        onClose: function () {
          router.replace({name: '/login'})
        }
      })
      break
    case 401:
      Message.error({
        message: '未授权，请登录',
        onClose: function () {
          router.replace({name: 'error-404'})
        }
      })
      break
    case 403:
      Message.error({
        message: '拒绝访问',
        onClose: function () {
          // router.push({name: 'error-403'})
        }
      })
      break
    case 404:
      Message.error({
        message: '请求地址出错',
        onClose: function () {
          // router.push({name: 'error-404'})
        }
      })
      break
    case 408:
      Message.error({
        message: '请求超时',
        onClose: function () {
          // router.push({name: 'error-404'})
        }
      })
      break
    case 500:
      Message.error({
        message: '服务器内部错误',
        onClose: function () {
          // router.push({name: 'error-500'})
        }
      })
      break
    default:
      return response
  }
}

// 请求方式的配置
export default {
  post(url, data, method = 'post') { //  post
    return axios({
      method: method,
      baseURL: config.baseURL,
      url,
      data: data,
      timeout: 15000,
      paramsSerializer: params => {
        // 解决数组传递问题
        return qs.stringify(params, {arrayFormat: 'indices'})
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    )
  },
  get(url, params) { // get
    return axios({
      method: 'get',
      baseURL: config.baseURL,
      url,
      params, // get 请求时带的参数
      timeout: 5000,
      paramsSerializer: params => {
        // 解决数组传递问题
        return qs.stringify(params, {arrayFormat: 'indices'})
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    )
  }
}
